import { render, staticRenderFns } from "./PriorityTypeCards.vue?vue&type=template&id=4c80da58&"
import script from "./PriorityTypeCards.vue?vue&type=script&lang=js&"
export * from "./PriorityTypeCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports